var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('common-list2',{attrs:{"conditions":_vm.conditions,"msg":'1,000,090 首',"is-single-selection":true},on:{"handleClickUnlimit":_vm.clickUnlimit,"handleClickItem":_vm.clickCondition}})}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-65f9fa1e","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav_poetry/PoetryClassList.vue
// module id = 1566
// module chunks = 0